import { ClimateRegion } from './types';

// 3-digit zip prefixes whose climate diverges from their state's default in
// CLIMATE_REGION_BY_STATE. Assignments follow DOE/IECC climate zones collapsed
// to the engine's five buckets. Only climate-diverse states need entries; a
// test enforces that every prefix belongs to a served state and actually
// differs from that state's default. Keys are in ascending prefix order
// (lint), so state groups are annotated inline.
export const CLIMATE_REGION_BY_ZIP_PREFIX: Record<string, ClimateRegion> = {
  // New York (default COLD): NYC metro + Long Island are IECC zone 4A
  '100': 'MIXED',
  '101': 'MIXED',
  '102': 'MIXED',
  '103': 'MIXED',
  '104': 'MIXED',
  '105': 'MIXED',
  '106': 'MIXED',
  '107': 'MIXED',
  '108': 'MIXED',
  '109': 'MIXED',
  '110': 'MIXED',
  '111': 'MIXED',
  '112': 'MIXED',
  '113': 'MIXED',
  '114': 'MIXED',
  '115': 'MIXED',
  '116': 'MIXED',
  '117': 'MIXED',
  '118': 'MIXED',
  '119': 'MIXED',
  // Texas (default HOT_HUMID): Panhandle and West Texas are dry
  '790': 'HOT_DRY',
  '791': 'HOT_DRY',
  '792': 'HOT_DRY',
  '793': 'HOT_DRY',
  '794': 'HOT_DRY',
  '795': 'HOT_DRY',
  '796': 'HOT_DRY',
  '797': 'HOT_DRY',
  '798': 'HOT_DRY',
  '799': 'HOT_DRY',
  // Arizona (default HOT_DRY): Flagstaff / high country
  '860': 'COLD',
  // Texas: El Paso's outlying 885 prefix, same dry west as 798-799
  '885': 'HOT_DRY',
  // Nevada (default HOT_DRY): Reno, Carson City, Elko (zone 5B)
  '894': 'COLD',
  '895': 'COLD',
  '897': 'COLD',
  '898': 'COLD',
  // California (default MARINE): LA basin + inland SoCal cool by ocean far
  // less than the Bay Area; cooling dominates summer bills
  '900': 'HOT_DRY',
  '901': 'HOT_DRY',
  '902': 'HOT_DRY',
  '903': 'HOT_DRY',
  '904': 'HOT_DRY',
  '905': 'HOT_DRY',
  '906': 'HOT_DRY',
  '907': 'HOT_DRY',
  '908': 'HOT_DRY',
  '910': 'HOT_DRY',
  '911': 'HOT_DRY',
  '912': 'HOT_DRY',
  '913': 'HOT_DRY',
  '914': 'HOT_DRY',
  '915': 'HOT_DRY',
  '916': 'HOT_DRY',
  '917': 'HOT_DRY',
  '918': 'HOT_DRY',
  // California: Riverside / San Bernardino / deserts
  '922': 'HOT_DRY',
  '923': 'HOT_DRY',
  '924': 'HOT_DRY',
  '925': 'HOT_DRY',
  // California: Central Valley (Bakersfield, Mojave, Fresno, Stockton,
  // Modesto, Sacramento, Marysville, Redding)
  '932': 'HOT_DRY',
  '933': 'HOT_DRY',
  '935': 'HOT_DRY',
  '936': 'HOT_DRY',
  '937': 'HOT_DRY',
  '938': 'HOT_DRY',
  '952': 'HOT_DRY',
  '953': 'HOT_DRY',
  '956': 'HOT_DRY',
  '957': 'HOT_DRY',
  '958': 'HOT_DRY',
  '959': 'HOT_DRY',
  '960': 'HOT_DRY',
  // California: Sierra (Truckee / Tahoe)
  '961': 'COLD',
  // Oregon (default MARINE): east of the Cascades + Klamath/Bend
  '976': 'COLD',
  '977': 'COLD',
  '978': 'COLD',
  '979': 'COLD',
  // Washington (default MARINE): east of the Cascades
  // (Wenatchee, Yakima, Spokane, Tri-Cities, Walla Walla)
  '988': 'COLD',
  '989': 'COLD',
  '990': 'COLD',
  '991': 'COLD',
  '992': 'COLD',
  '993': 'COLD',
  '994': 'COLD',
};
